import { render, staticRenderFns } from "./FiringsViewComponent.vue?vue&type=template&id=01880d07&scoped=true&"
import script from "./FiringsViewComponent.vue?vue&type=script&lang=js&"
export * from "./FiringsViewComponent.vue?vue&type=script&lang=js&"
import style0 from "./FiringsViewComponent.vue?vue&type=style&index=0&id=01880d07&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "01880d07",
  null
  
)

export default component.exports